import { axiosInstance } from '../../helpers/api_helper';

const updateBuyerStatus = async (formData: any) => {
  try {
    console.log('FormData in updateBuyerStatus:', formData);

    const response = await axiosInstance.patch(`/Customers/UpdateCustomerStatus`, formData);

    console.log('API Response from updateBuyerStatus:', response); // Log the response

    if (response.data.status === "00") {
      // Handle success, if needed
      return response.data;
    } else {
      // Handle error
      throw new Error('Error updating buyer status');
    }
  } catch (error:any) {
    // Handle network or other errors
    throw new Error(`Error: ${error.message}`);
  }
};

export { updateBuyerStatus };
